<template>
  <div class="row px-4">
    <div class="col-md-12 col-sm-12 mb-4" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <div class="text-center">
        <button v-if="!readonly && !showVouched" @click="startVerification" class="btn btn-secondary btn-default  btn-gray"><i class="fal fa-square fa-1x"></i> Start verification</button>
        <button v-if="readonly" class="btn btn-success btn-default"><i class="fal fa-check-square fa-1x"></i>Verification completed!</button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="mx-auto">
        <vouched v-if="showVouched"
          :first-name="applicationData.first_name"
          :last-name="applicationData.last_name"
          :email="applicationData.email"
          :phone="applicationData.phone"
          @vouched-response="vouchedResponse"
        ></vouched>
        <more-info v-else />
      </div>
    </div>
  </div>
</template>
<script>
import '@/shared/validations.js'
import Vue from 'vue'
import FileUpload from '@/shared/uploaders/file.vue'
import Vouched from './vouched.vue'
import MoreInfo from './more_info.vue'
import BackButton from './back_button.vue'

export default {
  components: {
    FileUpload, Vouched, MoreInfo, BackButton
  },
  props: {
    readonly: {
      type: Boolean,
      required: true
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      errors: $errors,
      options: $options,
      showVouched: false
    }
  },
  methods: {
    startVerification() {
      this.showVouched = true
    },
    vouchedResponse({ token, error }) {
      console.log("vouchedResponse received", token, error)
      if (token) {
        this.$emit('update', { vouchedVerification: true, token: token })
      } else {
        this.$emit('update', { vouchedVerification: false, error: 'Vouched error message' })
      }
    }
  }
}
</script>
